// TODO: update Ad API in fly-listings to be compatible with this implementation
// so we can reuse that component instead of having to maintain both
import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import throttle from 'lodash/throttle'
import isFunction from 'lodash/isFunction'

import { SponsoredAd } from './SponsoredAd/SponsoredAd'
import { StandardAd } from './StandardAd/StandardAd'
import { InlineAd } from './InlineAd/InlineAd'
import { ADS_INFO, RESPONSIVE_SIZES } from './constants'
import { pclnExpt } from '../../../common/fly-experimentation/fly-experimentation'

import { ClientGlobals } from '../../../common/client-globals/client-globals'

class Ad extends React.Component {
  constructor(props) {
    super(props)

    if (window.googletag) {
      window.googletag.cmd.push(function() {
        // TODO: future README
        // this does not work with Google Programmable Ads (GPA)
        // the size is critical here, if it is wrong, enableSingleRequest will not work
        window.googletag.pubads().enableSingleRequest()

        window.googletag.enableServices()
      })
    }

    this.state = {
      deviceType: this.getDeviceType(),
      shown: false,
      stickyHeader: false,
    }

    this.getClassName = () => {
      const { className } = this.props
      let adClassName = className || 'desktop-only-show ad'

      if (this.state.stickyHeader) {
        adClassName = adClassName + ' sticky-search-header-ad'
      }

      return adClassName
    }

    this.throttledUpdateDimensions = throttle(() => {
      this.setState(prevState => {
        const newDeviceType = this.getDeviceType()
        if (prevState.deviceType !== newDeviceType) {
          if (!prevState.shown) {
            prevState.shown = true
            this.publishAd()
            this.refreshAds()
            window.googletag.cmd.push(() => {
              window.googletag.display(this.props.adId)
            })
          } else {
            this.refreshAds()
          }
          return {
            deviceType: newDeviceType,
            state: prevState.shown,
          }
        }
        return prevState
      })
    }, 250)
  }

  publishAd(tryToLoad = false) {
    const { adId, inlineAds } = this.props
    const adObj = ADS_INFO[adId]
    const { adUnitPath: defaultAdUnitPath, adSize } = adObj

    const adUnitPath = defaultAdUnitPath

    // Short circuit if trying to load and isnt above min-width
    if (tryToLoad) {
      const minWidth = adObj.minWidth || 0
      const maxWidth = adObj.maxWidth || Infinity
      const currentWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth ||
        0

      if (currentWidth < minWidth || currentWidth > maxWidth) {
        return
      }
    }

    if (window.googletag && window.gptadslots) {
      window.googletag.cmd.push(() => {
        // Check if already defined
        if (!this.slot) {
          // the size is critical here, if it is wrong, enableSingleRequest will not work
          this.slot = window.googletag.defineSlot(adUnitPath, adSize, adId)

          if (!this.slot) {
            return false
          }
        }

        // Reponsive size mapping
        const mapping = window.googletag.sizeMapping()
        this.addGoogleTagMapping(mapping, 0, adObj)
        this.addGoogleTagMapping(mapping, 1280, adObj)
        const builtMap = mapping.build()
        this.slot.defineSizeMapping(builtMap)

        // Define targets
        const targets = !inlineAds
          ? this.buildGptDartAdTargets()
          : this.buildGptDartAdTargetsInline()
        targets.forEach(target => {
          this.slot.setTargeting(target.key, target.value)
        })

        // Custom targets
        this.addCustomTargeting(adObj, this.slot)

        // Add publish service
        this.slot.addService(window.googletag.pubads())

        // Add to window
        window.gptadslots.push(this.slot)

        // Publish
        window.googletag.pubads()

        return true
      })
    }
  }

  addCustomTargeting(adObj, slot) {
    const targets = adObj.setTargeting
    if (targets instanceof Array) {
      targets.forEach(target => {
        slot.setTargeting(target[0], target[1])
      })
    }
  }

  addGoogleTagMapping(mappingObj, minWidth, adObj) {
    if (adObj[minWidth]) {
      mappingObj.addSize([minWidth, 0], adObj[minWidth])
    }
  }

  buildGptDartAdTargets() {
    let targets = []
    const PCLN_BOOTSTRAP_DATA = this.props.pclnBootstrapData
    const slices = get(PCLN_BOOTSTRAP_DATA, 'searchRequest.slices')
    const airports = get(PCLN_BOOTSTRAP_DATA, 'searchRequest.airports')
    const refId =
      get(PCLN_BOOTSTRAP_DATA, 'requestLocals.referral.sourceId', '') +
      get(PCLN_BOOTSTRAP_DATA, 'requestLocals.referral.id', '')

    if (slices && slices.length && airports) {
      // Get the params from url
      const origin = slices[0].originAirport
      const destination =
        slices.length > 1
          ? slices[slices.length - 1].originAirport
          : slices[0].destinationAirport

      // Get the data from params
      const originData = airports[origin]
      const destinationData = airports[destination]

      // Get the city code
      const depcity = originData.cityCode
      const retcity = destinationData.cityCode

      // Get the airport code
      const oairport = slices[0].route_airport
        ? slices[0].route_airport.split('-')[0]
        : originData.airportCode
      const dairport = slices[0].route_airport
        ? slices[0].route_airport.split('-')[1]
        : destinationData.airportCode

      // Set as targets
      targets = [
        {
          key: 'depcity',
          value: depcity,
        },
        {
          key: 'retcity',
          value: retcity,
        },
        {
          key: 'oairport',
          value: oairport,
        },
        {
          key: 'dairport',
          value: dairport,
        },
        {
          key: 'route_airport',
          value: slices[0].route_airport
            ? slices[0].route_airport
            : `${oairport}-${dairport}`.toUpperCase(),
        },
        {
          key: 'route_city',
          value: slices[0].route_city
            ? slices[0].route_city
            : `${depcity}-${retcity}`.toUpperCase(),
        },
        {
          key: 'refid',
          value: refId,
        },
      ]
    }

    return targets
  }

  buildGptDartAdTargetsInline() {
    const { departingFrom, returningFrom, searchReferralId } = this.props
    let targets = []

    if (departingFrom && returningFrom) {
      targets = [
        {
          key: 'depcity',
          value: departingFrom.cityCode,
        },
        {
          key: 'retcity',
          value: returningFrom.cityCode,
        },
        {
          key: 'oairport',
          value: departingFrom.airportCode,
        },
        {
          key: 'dairport',
          value: returningFrom.airportCode,
        },
        {
          key: 'refid',
          value: searchReferralId,
        },
      ]
    }

    return targets
  }

  refreshAds() {
    if (window.googletag && window.googletag.pubads && this.slot) {
      const adService = window.googletag.pubads()

      if (isFunction(adService.refresh)) {
        adService.refresh([this.slot])
      }
    }
  }

  getDeviceType() {
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth ||
      0

    let deviceType
    if (width < 840) {
      deviceType = 'hidden'
    } else if (width >= 1280) {
      deviceType = 'larger'
    } else {
      deviceType = 'smaller'
    }

    return deviceType
  }

  componentDidMount() {
    window.addEventListener('resize', this.throttledUpdateDimensions)

    const { isSponsored, adId } = this.props

    if (window.googletag) {
      window.googletag.cmd.push(() => {
        window.googletag.display(adId)
      })
    }

    if (
      isSponsored &&
      ClientGlobals.initialDeviceWidth >= RESPONSIVE_SIZES.DESKTOP
    ) {
      pclnExpt.fireImpression('AIR_LISTINGS_FILTER_REDESIGN_SHOW_SELECTED_2')
    }

    this.props.pushAd(adId)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.throttledUpdateDimensions)
  }

  render() {
    const {
      inlineAds,
      isSponsored,
      adId,
      gaIndex,
      listingsLastUpdateTime,
      minScreenSize,
      isSticky,
      marginBottom,
    } = this.props
    return isSponsored ? (
      <SponsoredAd adId={adId} gaIndex={gaIndex} />
    ) : inlineAds ? (
      <InlineAd gaIndex={gaIndex} adId={adId} className={this.getClassName()} />
    ) : (
      <StandardAd
        className={this.getClassName()}
        listingsLastUpdateTime={listingsLastUpdateTime}
        minScreenSize={minScreenSize}
        isSticky={isSticky}
        adId={adId}
        marginBottom={marginBottom}
      />
    )
  }
}

Ad.propTypes = {
  adId: PropTypes.string.isRequired,
  pclnBootstrapData: PropTypes.object.isRequired,
  marginBottom: PropTypes.number,
  className: PropTypes.string,

  // push add to redux store
  pushAd: PropTypes.func,

  // should ad be sticky in its parent element as user scrolls vertically
  isSticky: PropTypes.bool,

  // timestamp of last listings update
  listingsLastUpdateTime: PropTypes.number,

  // use this media query to set CSS display property. ad will only appear on screens >= this width.
  // this value must match a key defined in air-theme/flyQueries.
  minScreenSize: PropTypes.string,

  // Mobile Ads Props
  gaIndex: PropTypes.number,
  departingFrom: PropTypes.shape({
    cityCode: PropTypes.string,
    airportCode: PropTypes.string,
  }),
  returningFrom: PropTypes.shape({
    cityCode: PropTypes.string,
    airportCode: PropTypes.string,
  }),
  searchReferralId: PropTypes.string,
  inlineAds: PropTypes.bool,
  isSponsored: PropTypes.bool,
}

export { Ad }
